import I18n from '@triotech/vue-core/src/plugins/i18n';
import Router from '@triotech/vue-core/src/plugins/router';

export default {
  i18n: I18n,
  router: Router,
  computed: {
    data() {
      return this.get().testData || {};
    },
    careerId() {
      return this.data.careerId;
    },
    inProgress() {
      return this.data.inProgress;
    },
    url(){
      return this.data.url;
    },
    moduleLabel() {
      return this.data.syllabus_localised_name;
    },
    label() {
      return this.data.label;
    },
    fullLabel() {
      return `${this.moduleLabel} - ${this.label}`;
    },
    image() {
      return this.data.image;
    },
    images() {
      return this.data.test_images;
    },
  },
  methods: {
    getBeforeTestData(careerId, inProgress,url) {
      this.setCareerId(careerId);
      this.setInProgress(inProgress);
      this.setUrl(url);
      return this.$ajax.get(`before_test/info/${this.careerId}?in_progress=${this.inProgress}`);
    },
    getInitTest() {
      return this.$ajax.get(`before_test/init/${this.careerId}?in_progress=${this.inProgress}`);
    },
    getAdvertising() {
      return this.$ajax.get(`before_test/advertising/${this.careerId}?in_progress=${this.inProgress}`);
    },
    getImages() {
      return this.$ajax.get(`before_test/preload/${this.careerId}?in_progress=${this.inProgress}`).then((imgs) => {
        this.setImages(imgs);
        return imgs;
      });
    },
    startTest() {
      const { unlockCode } = this.get();
      return this.$ajax.get(`before_test/start/${this.careerId}?in_progress=${this.inProgress}&unlock_code=${unlockCode}&url=${encodeURIComponent(this.url)}`).then((data) => {
        this.setTotalTime(data.total_time);
        this.setExamId(data.exam_id);
      });
    },
    getQuestion() {
      return this.$ajax.get(`test/?career=${this.careerId}`);
    },
    postTest(action, answer) {
      let model = {};

      if (action === 'validate' && this._.isEmpty(answer)) {
        model = {
          action: 'validate',
          answer: [],
        };
      } else if (action === 'postpone') {
        model = {
          action: 'postpone',
        };
      } else if (action === 'noAnswer') {
        model = {
          action: 'validate',
          answer: [],
        };
      } else {
        model = answer;
      }

      return this.$ajax.post(`test/?career=${this.careerId}`, model);
    },
    getTimeOut() {
      return this.$ajax.get(`test/time_out?career=${this.careerId}`);
    },
    quitTest() {
      return this.$ajax.get(`test/quit?career=${this.careerId}`).then(() => {
        if (this.$helper.isPlayerCertif || this.$helper.isPlayerDemo36) {
          this.$router.push({ name: 'result' });
        } else {
          if(this.url.length)
          {
            window.location.replace(`${this.url}`);
          }
          else{
            this.$router.push({ name: 'logout' });
          }

        }
      });
    },
    finishedTest() {
      return this.$ajax.get(`test/${this.data.exam_id}/result`);
    },
    pdf() {
      return this.$ajax.get(`test/${this.data.exam_id}/pdf`, null, { responseType: 'blob' }).then(data => this.$fs.download(data, 'Rapport.pdf', 'application/pdf'));
    },
    unsetData() {
      this.unset('testData');
    },
    setData(data) {
      this.set({ testData: this._.extend({}, this.data, data) });
    },
    setCareerId(id) {
      this.setData({ careerId: id });
    },
    setUrl(url) {
      this.setData({url});
    },
    setInProgress(inProgress) {
      this.setData({ inProgress });
    },
    setInitialData(data) {
      this.setData({
        label: data.test.label,
        language: data.test.language,
        image: data.test.image,
        syllabus_localised_name: data.syllabus_localised_name,
      });
    },
    setTotalTime(totalTime) {
      this.setData({ total_time: totalTime });
    },
    setExamId(examId) {
      this.setData({ exam_id: examId });
    },
    setImages(testImages) {
      this.setData({ test_images: testImages });
    },
  },
};
